import { Component, OnInit, Input } from '@angular/core';
import { EQUIPMENT_STATUS } from 'src/app/domains/equipment/models';

@Component({
  selector: 'gdp-equipment-status',
  template: '<div [class]="statusClass">{{status}}</div>'
})
export class EquipmentStatusComponent implements OnInit {
  @Input('status') status: EQUIPMENT_STATUS;
  public statusClass: string;
  private classMapping = {
    [EQUIPMENT_STATUS.AVAILABLE]: 'vox-chip vox-chip_aquamarine',
    [EQUIPMENT_STATUS.ALLOCATED]: 'vox-chip vox-chip_royal-blue-text',
    [EQUIPMENT_STATUS.ASSIGNED]: 'vox-chip vox-chip_royal-blue'
  };
  constructor() { }

  ngOnInit() {
    this.statusClass = this.classMapping[this.status];
  }

}
